import { FC } from 'react'
import { Col, Row } from '@/root/shared-types'
import { TableHeader } from '@/root/components/tuuleliinid'
import { TableBody } from '@/root/modules/tuuleliinid/TariffsPage/components/TableBody/TableBody'

interface TariffsTableProps {
  cols: Col[]
  rows: Row[]
}

export const TariffsTable: FC<TariffsTableProps> = ({ rows, cols }) => (
  <div className="w-full">
    <TableHeader cols={cols} className="grid grid-cols-2" />
    <TableBody rows={rows} />
  </div>
)
